import {
  logoutHandlerFactory
} from "../chunk-W4TWOJ4Y.js";
import "../chunk-UEDPR2CR.js";
import "../chunk-KVCLZREV.js";
import "../chunk-2CSC3FHL.js";

// lib/logout/process-env.ts
if (typeof globalThis.process === "undefined") {
  ;
  globalThis.process = { env: {} };
}

// lib/logout/logoutOnIdle.tsx
import { logDebug, logInfo } from "@lune/common/logger";
import { useEffect } from "react";
import { IdleTimerProvider } from "react-idle-timer";
import { jsx } from "react/jsx-runtime";
var DEFAULT_LOGOUT_ON_IDLE_MS = 5 * 60 * 1e3;
var OVERRIDE_LOGOUT_ON_IDLE_MS = parseInt(
  process.env.LOGOUT_TIMEOUT_MS ?? "0"
);
var LogoutOnIdle = ({
  version,
  timeoutMs = OVERRIDE_LOGOUT_ON_IDLE_MS !== 0 ? OVERRIDE_LOGOUT_ON_IDLE_MS : DEFAULT_LOGOUT_ON_IDLE_MS,
  loginUrl,
  rootUrl,
  disabled = false
}) => {
  useEffect(() => {
    if (!disabled) {
      logDebug(
        "Setting up logoff on idle",
        timeoutMs / 1e3,
        "seconds to",
        loginUrl
      );
    }
  }, [disabled, loginUrl, timeoutMs]);
  if (disabled) {
    logInfo("Logoff on idle disabled");
    return null;
  }
  return /* @__PURE__ */ jsx(
    IdleTimerProvider,
    {
      timeout: timeoutMs,
      onIdle: () => {
        logInfo("Idle threshold reached. Logging off...");
        const logout = logoutHandlerFactory(version, loginUrl, rootUrl);
        logout();
      }
    }
  );
};
export {
  LogoutOnIdle
};
